__turbopack_context__.v({
  "className": "kaieuq_className",
  "variable": "kaieuq_variable",
});
